"use client";
import Link from 'next/link';
import { format } from 'date-fns';
import sv from 'date-fns/locale/sv';

// Client Component: Renders a list of articles
interface Article {
  _id: string;
  title: string;
  slug: { current: string };
  date: string;
}

interface ArticlesListProps {
  articles: Article[];
}

export function ArticlesList({ articles }: ArticlesListProps) {
  return (
    <section className="container mx-auto px-4 py-16">
      <h1 className="text-3xl font-bold mb-8">Senaste Artiklar</h1>
      <ul className="space-y-6">
        {articles?.map((article) => (
          <li key={article._id}>
            <Link
              href={`/artiklar/${article.slug.current}`}
              className="text-xl text-blue-700 hover:underline"
            >
              {article.title}
            </Link>
            <p className="text-sm text-gray-500">
              {format(new Date(article.publishedDate), "d MMMM yyyy", { locale: sv })}
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
}